<template lang="html">
 	<div class="downloadList-container">
    <div class="breadCrumb-container">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>{{$t('message.terminal')}}</el-breadcrumb-item>
				<el-breadcrumb-item>{{$t('message.addTerminal')}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

    <div class="body-container">
      <div class="table-container password-container verifone-panel">
        <div class="password-item">
          <div class="item-left">
            <span class="required-icon">*</span><span>SN</span>
          </div>
          <div class="item-right">
            <el-input v-model="sn" type="text"></el-input>
          </div>
        </div>

        <div class="password-item">
          <div class="item-left">
            <span>{{$t('message.deviceId')}}</span>
          </div>
          <div class="item-right">
            <el-input v-model="deviceId" type="text"></el-input>
          </div>
        </div>

				<div class="password-item">
          <div class="item-left">
            <span class="required-icon">*</span><span>{{$t('message.model')}}</span>
          </div>
          <div class="item-right">
						<el-select v-model="modelValue" :placeholder="$t('message.pleaseChoose')">
							<el-option v-for="item in modelOptions" :key="item" :label="item" :value="item"></el-option>
						</el-select>
          </div>
        </div>

				<div class="password-item">
          <div class="item-left">
            <span class="required-icon">*</span><span>{{$t('message.merchant')}}</span>
          </div>
          <div class="item-right">
            <el-select v-model="merchantValue" filterable :placeholder="$t('message.pleaseChoose')">
              <el-option v-for="item in merchantOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
          </div>
        </div>

				<div class="password-item">
          <div class="item-left">
            <span>{{$t('message.group')}}</span>
          </div>
          <div class="item-right">
            <el-select v-model="groupValue" multiple collapse-tags :placeholder="$t('message.pleaseChoose')" filterable >
							<el-option v-for="item in groupOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
          </div>
        </div>

        <!--<div class="password-item trigger-item">
          <div class="item-left">
            <span>{{$t('message.relocationAlert')}}</span>
          </div>
          <div class="item-right trigger-right">
            <el-radio-group v-model="triggerValue">
              <el-radio :label="1">{{$t('message.yes')}}</el-radio>
              <el-radio :label="0">{{$t('message.no')}}</el-radio>
            </el-radio-group>
            <div class="moving-container">
              <span>{{$t('message.movingDistance')}}:</span>
              <el-input :disabled="!triggerValue" class="distance" v-model="distance" type="text"></el-input>
              <span>m</span>
            </div>
          </div>
        </div>-->

        <!--<div id="container" style="width:100%; height:350px; margin: 10px auto" />-->

        <div class="submit-container">
          <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{$t('message.back')}}</el-button>
          <el-button class="verifone-btn" type="primary" icon="el-icon-document" @click="save">{{$t('message.submit')}}</el-button>
        </div>
      </div>
    </div>
 	</div>
</template>

<script>
export default {
	data() {
		return {
      count:'',
      modelOptions: ['X990', 'X970', 'X950'],
      merchantOptions: [],
      groupOptions: [],
      modelValue: 'X990',
      merchantValue: '',
      groupValue: [],
      sn: '',
      deviceId: '',
      inputCheck: this.$t('message.inputCheck'),
      modifySuccess: this.$t('message.addSuccess'),

      // --------------------------------------------------  移机预警配置  --------------------------------------------------
      // terminalMoveConfigMarker:'',
      // terminalMoveConfigGoogleMap: '',
       triggerValue: 0,
       distance: '',
      // terminalMoveConfigLat:'',
      // terminalMoveConfigLng:'',


		}
	},

  mounted() {
      this.queryMerchant();
      this.queryGroup();
      // this.terminalMoveConfigGoogleMapInit();
  },

	computed: {
		updateDownload: function() {
			return !this.triggerValue;
		},
	},

	methods: {
    callBack() {
      this.$router.replace('/terminalList');
    },
    save() {
      let obj = {
        sn: this.sn,
        model: this.modelValue,
        merchantId: this.merchantValue,
        groupList: this.groupValue,
        deviceId: this.deviceId,
        moveConf: this.triggerValue
      };

      if(this.triggerValue) {
        obj.distance = this.distance;
        // obj.terminalMoveConfigInitialLat = this.terminalMoveConfigLat;
        // obj.terminalMoveConfigInitialLng = this.terminalMoveConfigLng;
      }

      if(!this.sn || this.sn == '' || !this.modelValue || this.modelValue == '' || !this.merchantValue || this.merchantValue == '') {
        this.yjMessage.showErrorMsg(this.inputCheck);
        return;
      }

      this.$axios({
        method: 'post',
        url: '/marketplace/terminal/add',
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
        data: obj
      }).then(response => {
        if (response.data.resultCode != 0) {
          this.yjMessage.showErrorMsg(response.data.desc);
          return;
        }else {
          this.yjMessage.showSuccessMsg(this.modifySuccess);
          this.$router.replace('/terminalList');
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    queryMerchant() {
      this.$axios({
        method: 'post',
        url: '/marketplace/common/query/merchant',
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
      }).then(response => {
        if (response.data.resultCode != 0) {
          this.yjMessage.showErrorMsg(response.data.desc);
          return;
        }else {
          this.merchantOptions = response.data.merchants;
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    queryGroup() {
      this.$axios({
        method: 'post',
        url: '/marketplace/common/query/group',
        headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
      }).then(response => {
        if (response.data.resultCode != 0) {
          this.yjMessage.showErrorMsg(response.data.desc);
          return;
        }else {
          this.groupOptions = response.data.groups;
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    // 部署预警配置（谷歌地图）
    /*terminalMoveConfigGoogleMapInit(){
      let that = this;
      that.terminalMoveConfigGoogleMap = new google.maps.Map(document.getElementById("container"), {
        zoom: 13,  //显示一个滑动条来控制map的Zoom级别
        zoomControl: false, // 删除地图上的“ 缩放”控件按钮。
        center: { lat: 13.982163, lng: 100.306070},  //设置地图中心点
        //disableDefaultUI: true,  //为了关闭默认控件集,设置地图的disableDefaultUI的属性为true
        //gestureHandling: 'cooperative', // 通过单击缩放控件来缩放地图
        mapTypeId: 'roadmap', // 控制地图的类型 roadmap：街道地图、terrain：地形地图、satellite：卫星地图、 hybrid：卫星图像+地名
      });

      // 点击事件
      google.maps.event.addListener(that.terminalMoveConfigGoogleMap, 'click', function (event) {
        that.terminalMoveConfigLat = event.latLng.lat();
        that.terminalMoveConfigLng = event.latLng.lng();

        // 清除先前的标记
        if (that.terminalMoveConfigMarker != ''){
          that.terminalMoveConfigMarker.setMap(null);
        }

        // 设置新的标记
        that.terminalMoveConfigMarker = new google.maps.Marker({
          //标点的位置
          position: event.latLng,
          map: that.terminalMoveConfigGoogleMap,
        });
      })
    },*/
	}

}
</script>

<style lang="css" scoped="scoped">
.table-container {
	margin-top: 60px;
  padding: 8vh 3vw;
}
.password-container {
    /* height: 70vh; */
}
.password-item {
    display: flex;
    display: -webkit-display;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    color: #666;
}
.trigger-item {
    align-items: flex-start;
}
.item-left {
    width: 18vw;
    text-align: right;
}
.item-right {
    padding-left: 15px;
    width: 30vw;
}
.required-icon {
    color: red;
    font-size: 20px;
}
.submit-container {
    margin-top: 3vh;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
}
.item-right .el-select {
    width: 100%;
}
.el-radio-group {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
}
.el-radio+.el-radio {
    margin: 8px auto 0 0;
}
.trigger-right {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
}
.distance {
    width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/TerminalAdd.vue